import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Container from '../Container/Container'

import * as styles from './Login.m.css'

async function doLogin(username: string, password: string) {
  const response = await fetch('/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ username, password, noRedirect: true }),
  })

  if (response.ok) {
    const text = await response.text()
    if (text === 'Password change required') {
      return true
    } else {
      return false
    }
  } else {
    console.error('Error logging in', response)
    return false
  }
}

const Login: React.FC = (): React.ReactElement => {
  const navigate = useNavigate()
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')

  const handleLogin: React.FormEventHandler<HTMLFormElement> = async (
    e: React.FormEvent<HTMLFormElement>,
  ) => {
    e.preventDefault()

    const passwordChangeRequired = await doLogin(username, password)

    if (passwordChangeRequired) {
      navigate('/change-password')
    } else {
      window.location.href = '/'
    }

    return false
  }

  const forgotPasswordClicked = () => {
    navigate('/forgot-password')
  }

  return (
    <Container>
      <form onSubmit={handleLogin} className={styles.loginForm}>
        <input
          type="text"
          name="username"
          placeholder="Username"
          onChange={(e) => setUsername(e.target.value)}
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          onChange={(e) => setPassword(e.target.value)}
        />
        <button type="submit">Login</button>
      </form>
      <p>
        Forgot username or password?{' '}
        <a onClick={forgotPasswordClicked}>Click Here</a>
      </p>
    </Container>
  )
}

export default Login
